let spanbtn, body, mobileSlide, mainMenu, clearFilterBtn, sizelistLiAnchor, inputBoxs,
  applyFilterBtn, sizeInputs, remSizeClicked, cusSortBy, prdTypeLinks, prdTypeInps;

document.addEventListener("DOMContentLoaded", () => {
  mobileSlide = document.getElementById("slide");
  body = document.getElementsByClassName("custom_overflow");
  mainMenu = document.getElementById("main_menu");
  spanbtn = document.getElementById("spanclose");
  applyFilterBtn = document.getElementById("cus_apply");
  clearFilterBtn = document.getElementById("cus_clear");
  sizeInputs = document.querySelectorAll(".cus_size_inp");
  remSizeClicked = document.querySelectorAll(".cus_rem_size");
  cusSortBy = document.querySelectorAll(".cus_sort_by");
  prdTypeLinks = document.querySelectorAll(".prd_type_link")
  prdTypeInps = document.querySelectorAll(".cus_prd_type")
  sizelistLiAnchor = document.querySelectorAll(".cus_size-remain li a");
  inputBoxs = document.querySelectorAll(".cus_apply_box");
  // const sizelistLi = document.querySelectorAll(".cus_size-remain li");
  // const side_block = document.querySelector(".side_block");  

  function applyFilter() {
    const BASE_URL = "https://corridornyc.com";
    const getCheckedUrls = (inputs, attribute) => { return Array.from(inputs).filter(input => input.checked).map(input => input.closest('li').getAttribute(attribute)).filter(val => val) };
    const redirectToUrl = (url) => { if (url) window.location.href = url };
    const catUrls = getCheckedUrls(prdTypeInps, 'value');
    const sizeUrls = getCheckedUrls(sizeInputs, 'data-tag');
    const sortUrls = getCheckedUrls(inputBoxs, 'value');
    const sort_queryParam = 'sort_by=';
    const size_queryParam_cat = '&constraint=';
    const coll_url = applyFilterBtn.getAttribute('data-url');
    // console.log({ sortUrls: sortUrls, sizeUrls: sizeUrls, catUrls: catUrls });

    function buildSizeUrl(baseUrl, sizeUrls, separator = '&', prefix = 'size-') {
      if (sizeUrls.length === 0) return baseUrl;
      const sizePart = sizeUrls.map((u) => prefix + u).join('+');
      return `${baseUrl}${separator}${sizePart}`;
    }
    
    function buildSortUrl(baseUrl, sortUrls, queryParam, separator = '&') {
      return sortUrls.length > 0 ? `${baseUrl}${separator}${queryParam}${sortUrls[0]}` : baseUrl;
    }
    
    if (catUrls.length > 0) {
      let url = `${BASE_URL}${catUrls[0]}`;
      url = buildSizeUrl(url, sizeUrls, size_queryParam_cat);
      url = buildSortUrl(url, sortUrls, sort_queryParam);
      redirectToUrl(url);
    } else {
      let url = `${BASE_URL}${coll_url}`;
      url = buildSizeUrl(`${url}/`, sizeUrls, '', 'size-');
      url = buildSortUrl(url.replace(/\/$/, ''), sortUrls, sort_queryParam, '?'); // Ensure trailing `/` is removed for sort param
      redirectToUrl(url);
    }
  }

  // Listen for the apply filter button click
  // applyFilterBtn.addEventListener("click", applyFilter);

  // clearFilterBtn.addEventListener("click", () => {
  //   const dataUrl = clearFilterBtn.getAttribute("data-url");
  //   const url = "https://corridornyc.com/collections/new-arrivals";
  //   window.location.href = url;
  // });
  
  function filterToogle(){
    const FilterBtn = document.getElementById("button");
    const filterBox = document.getElementById("cus_position");
    const filter_div = document.getElementById("custom_change");
    const cusDownArrow = document.getElementById("cus_down_arrow");

    cusDownArrow.style.transform=`rotate(0deg)`;
    cusDownArrow.style.transition=`all .1s ease`;
    FilterBtn.classList.add("cus_flex");
    if (window.innerWidth < 900) {
      spanbtn &&
        spanbtn.addEventListener("click", () => {
          spanbtn.classList.remove("rig_show");
          mobileSlide.classList.remove("slideing");
          mobileSlide.classList.remove("desk_slide");
          document.body.style.overflow = "";
        });

      FilterBtn &&
        FilterBtn.addEventListener("click", () => {
          if(spanbtn.classList.contains("rig_show")){
            spanbtn.classList.remove("rig_show");
            mobileSlide.classList.remove("slideing");
            mobileSlide.classList.remove("desk_slide");
            document.body.style.overflow = "";
          }else{
            spanbtn.classList.add("rig_show");
            mobileSlide.classList.add("slideing");
            document.body.style.overflow = "hidden";
            // console.log("filter btn cicked");
          }          
        });
    } else {
      applyFilterBtn.classList.add("cus_des_apply");
      clearFilterBtn.classList.add("cus_des_clear");
      cusDownArrow.style.transform = `rotate(0deg)`;
      let deskSlide = true;
      mobileSlide.style.marginTop = 0;

      spanbtn &&
      spanbtn.addEventListener("click", () => {
        mobileSlide.classList.remove("desk_slide");
        document.body.style.overflow = "";
        FilterBtn.click();
      });
      FilterBtn &&
        FilterBtn.addEventListener("click", () => {         
          if (deskSlide) {
            filter_div.style.paddingBottom = 0;
            cusDownArrow.classList.add("des_fil_icon");
            mobileSlide.classList.add("desk_slide");
            document.body.style.overflow = "hidden";                                             
            // console.log("desktop filter btn click open");
          } else {
            cusDownArrow.classList.remove("des_fil_icon");
            mobileSlide.classList.remove("desk_slide");
            document.body.style.overflow = "scroll";
            // console.log("desktop filter btn click closed");
          }

          deskSlide = !deskSlide;
        });
    }
  }
  filterToogle();

});
window.addEventListener('resize', function(){
  filterToogle();
})

const selectElement = document.querySelector(".sidebar_select.mobile_view");
selectElement.addEventListener("change", function (e) {
  const selectedValue = e.target.value;
  if (selectedValue) {
    window.location.href = selectedValue;
  }
});


//Filter options selection
function li_to_input_checkbox_click(e, single_click = false){
  let item = e.target;
  // if(item.closest('input[type=checkbox]')){ return }
  let parent_li = item.closest('li');
  let input = parent_li.querySelector('input[type=checkbox]');
  let input_flag = input.checked;

  !single_click && parent_li.classList.contains('active') ? parent_li.classList.remove('active') : '';
  parent_li.classList.contains('rem_befo') ? parent_li.classList.remove('rem_befo') : ''; 
  
  if(single_click && !input_flag){
    let all_checkboxes = parent_li.closest('ul').querySelectorAll('input[type=checkbox]');
    all_checkboxes.forEach( i => i.checked = false );
  }

  input.click();
}

function li_cls_removed_single_clck(e){
  let item = e.target;
  let all_li_s = item.closest('ul').querySelectorAll('li');

  all_li_s.forEach( i => {
    i.classList.contains('active') ? i.classList.remove('active') : ''; 
    i.classList.contains('cus_prd_type--active') ? i.classList.remove('cus_prd_type--active') : '';
  })
}

document.addEventListener('click', (e) => {
  let item = e.target;

  let sort_li = item.closest(".cus_align");
  let size_li = item.closest(".cus_rem_size");
  let type_li = item.closest('.cus_prd_type--li');
  let parent = item.closest('.coll-sidebar');

  if(sort_li && parent ){ li_cls_removed_single_clck(e); li_to_input_checkbox_click(e, true) }
  if(size_li && parent ){ li_to_input_checkbox_click(e) }
  if(type_li && parent ){ li_cls_removed_single_clck(e); li_to_input_checkbox_click(e, true) }
  
})

document.addEventListener("DOMContentLoaded", function () {
  // Step 1: Extract all size filter values from checkboxes
  const sizeFilters = Array.from(document.querySelectorAll(".cus_size_container li label input"))
    .map(input => input.value.toLowerCase());

  // Step 2: Fix for getting 'filter.v.option.size' from URL with dot
  const urlParams = new URLSearchParams(window.location.search);
  let selectedSize = null;

  for (const [key, value] of urlParams.entries()) {
    if (key === "filter.v.option.size") {
      selectedSize = value.toLowerCase();
      break;
    }
  }

  if (!selectedSize || !sizeFilters.includes(selectedSize)) {
    // console.log("No valid size filter selected in URL");
    return;
  }

  // console.log("Selected size from URL:", selectedSize);

  // Step 3: Loop through products and hide if selected size is disabled
  const productCards = document.querySelectorAll(".product-collection, .product-collecton");

  productCards.forEach(card => {
    const sizeSpans = card.querySelectorAll(".coll-prd_sizes .sizes span");

    sizeSpans.forEach(span => {
      const sizeText = span.textContent.trim().toLowerCase();

      if (sizeText === selectedSize && span.classList.contains("disabled")) {
        // console.log("Hiding sold-out product:", card);
        card.style.display = "none";
      }
    });
  });
});

